import { Box, Container } from "@mui/material";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import AdminShell from "./components/admin/AdminShell";
import Footer from "./components/Footer";
import { Header } from "./components/Header";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminCategoriesPage from "./pages/admin/category/Category";
import AdminLoginPage from "./pages/admin/login/Login";
import RecipeList from "./pages/admin/recipe/RecipeList";
import RecipeManage from "./pages/admin/recipe/RecipeManage";
import RecipeDetails from "./pages/user/recipe/RecipeDetails";
import PublicRecipeList from "./pages/user/recipe/RecipeList";

function App() {
    return (
        <BrowserRouter>
            <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
                <Header/>

                <Box component="main" sx={{ flex: 1, py: 3, display: "flex" }}>
                    <Container sx={{ flex: 1 }} maxWidth="xl">
                        <Routes>
                            <Route path="/" element={<PublicRecipeList />} />
                            <Route path="/recipes/:id" element={<RecipeDetails />} />

                            <Route path="/admin/login" element={<AdminLoginPage />} />

                            <Route
                                path="/admin/categories"
                                element={
                                    <ProtectedRoute>
                                        <AdminShell>
                                            <AdminCategoriesPage />
                                        </AdminShell>
                                    </ProtectedRoute>
                                }
                            />

                            {/* Recipes list */}
                            <Route
                                path="/admin/recipes"
                                element={
                                    <ProtectedRoute>
                                        <AdminShell>
                                            <RecipeList />
                                        </AdminShell>
                                    </ProtectedRoute>
                                }
                            />

                            {/* Create recipe */}
                            <Route
                                path="/admin/recipes/new"
                                element={
                                    <ProtectedRoute>
                                        <AdminShell>
                                            <RecipeManage />
                                        </AdminShell>
                                    </ProtectedRoute>
                                }
                            />

                            {/* Edit recipe */}
                            <Route
                                path="/admin/recipes/:id/edit"
                                element={
                                    <ProtectedRoute>
                                        <AdminShell>
                                            <RecipeManage />
                                        </AdminShell>
                                    </ProtectedRoute>
                                }
                            />

                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </Container>
                </Box>

                <Footer />
            </Box>
        </BrowserRouter>
    );
}

export default App;
